import {
    pseudoRandomBytes
} from "crypto";
import {
    throws
} from "assert";

import moment from 'moment';
/*
 * this.js maker 190730 
 */

export default {
    isNull(v) {
        return (v === undefined || v === null || v === 'undefined' || v === 'null' || v === '') ? true : false;
    },
    allMenuHeader(m) {
        var h = [];
        for (let i in m) {
            for (let j in m[i].subs) {
                for (let k in m[i].subs[j].column) {
                    m[i].subs[j].column[k].mid = m[i].subs[j].id;
                }
                h = h.concat(m[i].subs[j].column);
            }
        }
        return h;
    },
    menuHeader(id, m, g) { // menuid, menudata(Array), gubun ('0' All, '1' List, '2' Detail, '3' sample)
        var mn = '';
        var sn = '';
        var ms = '';
        var mt = '';
        var h = [];
        outer: for (let i in m) {
            inner: for (let j in m[i].subs) {
                if (m[i].subs[j].id === id) {
                    mn = m[i].mains;
                    sn = m[i].subs[j].menuName;
                    ms = m[i].subs[j].sheetId;
                    mt = m[i].subs[j].menuStatus;

                    if (g === 1) {
                        h = m[i].subs[j].listColumn;
                    } else if (g === 2) {
                        h = m[i].subs[j].detailColumn;
                    } else if (g === 3) {
                        h = m[i].subs[j].listColumn;
                        // h = m[i].subs[j].samples;
                    } else {
                        if (m[i].subs[j].listColumn.length > 0) {
                            // if (m[i].subs[j].listColumn[0].columnCode != 'No') m[i].subs[j].listColumn.unshift({ columnCode: 'No', id: this.rndStr(8) })
                            h = m[i].subs[j].listColumn;
                            h.sort(function (a, b) {
                                return a.order - b.order;
                            })
                            break outer;
                        }
                    }

                }
            }
        } //문제 생길시 No중복제거
        return [mn, sn, ms, h, mt];
    },
    menuHeader_route(route, m, g) { // menuid, menudata(Array), gubun ('0' All, '1' List, '2' Detail, '3' sample)
        var mn = '';
        var sn = '';
        var ms = '';
        var mt = '';
        var md = '';
        var h = [];
        outer: for (let i in m) {
            inner: for (let j in m[i].subs) {
                if (m[i].subs[j].menuRoute === route) {
                    mn = m[i].mains;
                    sn = m[i].subs[j].menuName;
                    ms = m[i].subs[j].sheetId;
                    mt = m[i].subs[j].menuStatus;
                    md = m[i].subs[j].id;

                    if (g === 1) {
                        h = m[i].subs[j].listColumn;
                    } else if (g === 2) {
                        h = m[i].subs[j].detailColumn;
                    } else if (g === 3) {
                        h = m[i].subs[j].listColumn;
                        // h = m[i].subs[j].samples;
                    } else {
                        if (m[i].subs[j].listColumn.length > 0) {
                            if (m[i].subs[j].listColumn[0].columnCode != 'No') m[i].subs[j].listColumn.unshift({ columnCode: 'No', id: this.rndStr(8) })
                            h = m[i].subs[j].listColumn;
                            h.sort(function (a, b) {
                                return a.order - b.order;
                            })
                            break outer;
                        }
                    }

                }
            }
        } //문제 생길시 No중복제거
        return [mn, sn, ms, h, mt, md];
    },    
    tabOrder(id, m) {
        var h = [];
        var o = 0;
        outer: for (let i in m) {
            inner: for (let j in m[i].subs) {
                if (m[i].subs[j].id === id) {
                    o = m[i].subs[j].jobOrder;
                    break outer;
                }
            }
        }
        outer: for (let i in m) {
            inner: for (let j in m[i].subs) {
                if (0 < Number(m[i].subs[j].jobOrder) && Number(m[i].subs[j].jobOrder) <= o) {
                    h.push(m[i].subs[j]);
                }
            }
        }
        h.sort(function (a, b) {
            return a.jobOrder - b.jobOrder;
        });
        return h;
    },
    tabOrderComfirm(id, m) {
        var h = [];
        var o = 0;
        outer: for (let i in m) {
            inner: for (let j in m[i].subs) {
                if (m[i].subs[j].id === id) {
                    o = m[i].subs[j].jobOrder;
                    break outer;
                }
            }
        }
        outer: for (let i in m) {
            inner: for (let j in m[i].subs) {
                if (0 < Number(m[i].subs[j].jobOrder) && Number(m[i].subs[j].jobOrder) <= o || m[i].subs[j].jobOrder == 9999) {
                    h.push(m[i].subs[j]);
                }
            }
        }
        h.sort(function (a, b) {
            return a.jobOrder - b.jobOrder;
        });
        return h;
    },
    resultTabs(mid, menuData) {
        let tabs = [];
        let currentMenu = {};
        for (let i of menuData) {
            for (let j of i.subs) {
                if (j.id == mid) {
                    currentMenu = j;
                }
            }
        }
        for (let i of menuData) {
            for (let j of i.subs) {
                for (let k = currentMenu.jobOrder-2; k > 0; k--) {
                    if (j.jobOrder == k) {
                        tabs.push(j);
                    }
                }
            }
        }
        tabs.push(currentMenu);
        return tabs;
    },
    preMid(d, m) {
        var h = '';
        var o = 0;
        outer: for (let i in m) {
            inner: for (let j in m[i].subs) {
                if (m[i].subs[j].id === d) {
                    o = m[i].subs[j].jobOrder;
                    break outer;
                }
            }
        }
        outer: for (let i in m) {
            inner: for (let j in m[i].subs) {
                if (Number(m[i].subs[j].jobOrder) === (o - 1)) {
                    h = m[i].subs[j].id;
                    break outer;
                }
            }
        }
        return h;
    },
    sampleHeader(d) {
        var h = [];
        d.forEach(a=>{
            a.subs.forEach(b=>{
                if(b.menuRoute === 'samples') h = b.listColumn;
            });
        });
        return h;
    },
    receptionHeader(d) {
        var h = [];
        d.forEach(a=>{
            a.subs.forEach(b=>{
                if(b.menuRoute === 'receptions') h = b.listColumn;
            });
        });
        return h;
    },
    thisHeader(d, i, t) {
        var h = [];
        d.forEach(a=>{
            a.subs.forEach(b=>{
                if(b.id === i){
                    if(t === 'H') h = b.listColumn;
                    else h = b.detailColumn;
                } 
            });
        });
        return h;
    },
    preStatus(d, m) {
        var h = '';
        var o = 0;
        outer: for (let i in m) {
            inner: for (let j in m[i].subs) {
                if (m[i].subs[j].id === d) {
                    o = m[i].subs[j].jobOrder;
                    break outer;
                }
            }
        }
        outer: for (let i in m) {
            inner: for (let j in m[i].subs) {
                if (Number(m[i].subs[j].jobOrder) === (o - 1)) {
                    h = m[i].subs[j].menuStatus;
                    break outer;
                }
            }
        }
        return h;
    },

    preStatusA(d, m) {
        var r = [];
        m.some(a => {
            let breakBool = false;
            a.subs.some(b => {
                if (d != b.id) {
                    if (!this.isNull(b.menuStatus)) r.push(b.menuStatus)
                } else {
                    breakBool = true;
                    return true;
                }
            });
            if (breakBool) return true;
        });
        return r;
    },

    nextMid(d, m) {
        var h = '';
        var o = 0;
        var n = 0;
        outer: for (let i in m) {
            inner: for (let j in m[i].subs) {
                if (m[i].subs[j].id === d) {
                    o = m[i].subs[j].jobOrder;
                    break outer;
                }
            }
        }
        outer: for (let i in m) {
            inner: for (let j in m[i].subs) {
                if (Number(m[i].subs[j].jobOrder) > Number(o)) {
                    if (n === 0) {
                        n = Number(m[i].subs[j].jobOrder);
                        h = m[i].subs[j].id;
                        break outer;
                    }
                }
            }
        }
        return h;
    },
    detailSamples(m) {
        var s = '';
        var h = [];
        outer: for (let i in m) {
            inner: for (let j in m[i].subs) {
                if (m[i].subs[j].menuRoute === 'samples') {
                    s = m[i].subs[j].sheetId;
                    for (let k in m[i].subs[j].listColumn) {
                        m[i].subs[j].listColumn[k].mid = m[i].subs[j].id;
                    }
                    h = m[i].subs[j].listColumn;
                    break outer;
                }
            }
        }
        return [s, h];
    },
    makeHeader(id, m, vv, idx) {
        ///s , r , d , v ???????????????????????????
        var s = '';
        var r = [];
        // detali컬럼
        var d = this.tabOrder(id, m);
        var v = this.isNull(vv) ? 2 : vv;

        for (let i in d) {
            if (d[i].listColumn.length > 0) {
                if (id != d[i].id || d[i].jobOrder == 1) {
                    for (let j in d[i].listColumn) {
                        if (d[i].listColumn[j].columnType === 'STRING') {
                            if (j < Number(v)) {
                                // console.log(d[i].listColumn[j])
                                // if (d[i].listColumn[j].columnAttr === 'receptionno') {
                                //     d[i].listColumn[j].gubun = 'list'
                                //     r.push(d[i].listColumn[j]);
                                // } else {
                                d[i].listColumn[j].mid = d[i].id
                                d[i].listColumn[j].gubun = 'list'
                                r.push(d[i].listColumn[j]);
                                // }
                            } else {
                                // console.log(d[i].listColumn[j])
                                d[i].listColumn[j].mid = d[i].id
                                d[i].listColumn[j].gubun = 'list'
                                r.push(d[i].listColumn[j]);
                            }
                        } else if (d[i].listColumn[j].columnType === 'LIST') {
                            d[i].listColumn[j].mid = d[i].id
                            d[i].listColumn[j].gubun = 'list'
                            r.push(d[i].listColumn[j]);
                        } else if (d[i].listColumn[j].columnType === 'DATE') {
                            d[i].listColumn[j].mid = d[i].id
                            d[i].listColumn[j].gubun = 'list'
                            r.push(d[i].listColumn[j]);
                        }
                    }
                } else {
                    if(!this.isNull(idx)){
                        for (let j in d[i].listColumn) {
                            d[i].listColumn[j].mid = d[i].id
                            d[i].listColumn[j].gubun = 'list'
                            r.push(d[i].listColumn[j]);
                        }
                    }
                    s = d[i].detail;
                }
            }
            if (d[i].detailColumn.length > 0) {
                for (let j in d[i].detailColumn) {
                    if (d[i].detailColumn[j].columnName != 'No') {
                        d[i].detailColumn[j].mid = d[i].id
                        d[i].detailColumn[j].gubun = 'detail'
                        r.push(d[i].detailColumn[j]);
                    }
                }
            } else {
                if (Number(d[i].jobOrder) === 1) {
                    var s = this.detailSamples(m);
                    for (let j in s[1]) {
                        if (s[1][j].columnName != 'No') {
                            if (j < 2) {
                                delete s[1][j].mid;
                                s[1][j].gubun = 'samples'
                                r.push(s[1][j]);
                            } else {
                                s[1][j].mid = d[i].id
                                s[1][j].gubun = 'samples'
                                r.push(s[1][j]);
                            }
                        }
                    }
                }
            }
        }
        return [s, r];
    },
    makeResultHeader(id, m, vv, idx) {
        ///s , r , d , v ???????????????????????????
        var s = '';
        var r = [];
        // detali컬럼
        var d = this.resultTabs(id, m);
        var v = this.isNull(vv) ? 2 : vv;

        for (let i in d) {
            if (d[i].listColumn.length > 0) {
                if (id != d[i].id || d[i].jobOrder == 1) {
                    for (let j in d[i].listColumn) {
                        if (d[i].listColumn[j].columnType === 'STRING') {
                            if (j < Number(v)) {
                                // console.log(d[i].listColumn[j])
                                // if (d[i].listColumn[j].columnAttr === 'receptionno') {
                                //     d[i].listColumn[j].gubun = 'list'
                                //     r.push(d[i].listColumn[j]);
                                // } else {
                                d[i].listColumn[j].mid = d[i].id
                                d[i].listColumn[j].gubun = 'list'
                                r.push(d[i].listColumn[j]);
                                // }
                            } else {
                                // console.log(d[i].listColumn[j])
                                d[i].listColumn[j].mid = d[i].id
                                d[i].listColumn[j].gubun = 'list'
                                r.push(d[i].listColumn[j]);
                            }
                        } else if (d[i].listColumn[j].columnType === 'LIST') {
                            d[i].listColumn[j].mid = d[i].id
                            d[i].listColumn[j].gubun = 'list'
                            r.push(d[i].listColumn[j]);
                        } else if (d[i].listColumn[j].columnType === 'DATE') {
                            d[i].listColumn[j].mid = d[i].id
                            d[i].listColumn[j].gubun = 'list'
                            r.push(d[i].listColumn[j]);
                        }
                    }
                } else {
                    if(!this.isNull(idx)){
                        for (let j in d[i].listColumn) {
                            d[i].listColumn[j].mid = d[i].id
                            d[i].listColumn[j].gubun = 'list'
                            r.push(d[i].listColumn[j]);
                        }
                    }
                    s = d[i].detail;
                }
            }
            if (d[i].detailColumn.length > 0) {
                for (let j in d[i].detailColumn) {
                    if (d[i].detailColumn[j].columnName != 'No') {
                        d[i].detailColumn[j].mid = d[i].id
                        d[i].detailColumn[j].gubun = 'detail'
                        r.push(d[i].detailColumn[j]);
                    }
                }
            } else {
                if (Number(d[i].jobOrder) === 1) {
                    var s = this.detailSamples(m);
                    for (let j in s[1]) {
                        if (s[1][j].columnName != 'No') {
                            if (j < 2) {
                                delete s[1][j].mid;
                                s[1][j].gubun = 'samples'
                                r.push(s[1][j]);
                            } else {
                                s[1][j].mid = d[i].id
                                s[1][j].gubun = 'samples'
                                r.push(s[1][j]);
                            }
                        }
                    }
                }
            }
        }
        return [s, r];
    },
    AllHeader(id, m, vv) {
        var s = '';
        var r = [];
        var d = this.tabOrder(id, m);
        
        var v = this.isNull(vv) ? 2 : vv;
        for (let i in d) {
            if (d[i].listColumn.length > 0) {
                for (let j in d[i].listColumn) {
                    if (d[i].listColumn[j].columnType === 'STRING') {
                        if (j < Number(v)) {
                            // console.log(d[i].listColumn[j])
                            // if (d[i].listColumn[j].columnAttr === 'receptionno') {
                            //     d[i].listColumn[j].gubun = 'list'
                            //     r.push(d[i].listColumn[j]);
                            // } else {
                            d[i].listColumn[j].mid = d[i].id
                            d[i].listColumn[j].gubun = 'list'
                            r.push(d[i].listColumn[j]);
                            // }
                        } else {
                            // console.log(d[i].listColumn[j])
                            d[i].listColumn[j].mid = d[i].id
                            d[i].listColumn[j].gubun = 'list'
                            r.push(d[i].listColumn[j]);
                        }
                    } else if (d[i].listColumn[j].columnType === 'LIST') {
                        d[i].listColumn[j].mid = d[i].id
                        d[i].listColumn[j].gubun = 'list'
                        r.push(d[i].listColumn[j]);
                    }
                }
                s = d[i].detail;
            }
            
            if (d[i].detailColumn.length > 0) {
                for (let j in d[i].detailColumn) {
                    if (d[i].detailColumn[j].columnName != 'No') {
                        d[i].detailColumn[j].mid = d[i].id
                        d[i].detailColumn[j].gubun = 'detail'
                        r.push(d[i].detailColumn[j]);
                    }
                }
            } else {
                if (Number(d[i].jobOrder) === 1) {
                    var s = this.detailSamples(m);
                    for (let j in s[1]) {
                        if (s[1][j].columnName != 'No') {
                            if (j < 2) {
                                delete s[1][j].mid;
                                s[1][j].gubun = 'samples'
                                r.push(s[1][j]);
                            } else {
                                s[1][j].mid = d[i].id
                                s[1][j].gubun = 'samples'
                                r.push(s[1][j]);
                            }
                        }
                    }
                }
            }
        }
        return [s, r];
    },
    makeData(s, n, c) {
        var r = [];
        var e = [];
        var t = '';
        if (n > 0) {
            t = 'name';
        } else {
            t = 'code';
        }
        for (let i in s) {
            // let d = []; //2021_10_15왜 여기가 배열???
            let d = {};
            for (let j in s[i]) {
                if (j != 'samples') {
                    if (Array.isArray(s[i][j])) {
                        d[j] = s[i][j][0][t];
                    } else {
                        d[j] = s[i][j];
                    }
                } else {
                    d[j] = s[i][j];
                }
            }
            r.push(d);
            d = []
        }

        if (r.length > 0) {
            if (!this.isNull(c)) {
                if (c.length > 0) {
                    let rs = [];
                    for (let i in r) {
                        if (!this.isNull(r[i].samples)) {
                            let rss = [];
                            for (let j in r[i].samples) {
                                c.filter(a => {
                                    if (r[i].samples[j].hasOwnProperty('detailId')) {
                                        if (r[i].samples[j].detailId.indexOf(a.detailId) === 0) rss = rss.concat(j);
                                    } else {
                                        if (r[i].samples[j].sampleId.indexOf(a.sampleId) === 0) rss = rss.concat(j);
                                    }
                                });
                            }
                            rss.sort((a, b) => {
                                return b - a;
                            });
                            rss.filter(a => {
                                r[i].samples.splice(a, 1);
                            });
                            if (r[i].samples.length < 1) {
                                rs = rs.concat(i);
                            }
                        } else {
                            c.filter(a => {
                                if (r[i].sampleId.indexOf(a.sampleId) === 0) rs = rs.concat(i);
                            })
                        }
                    }
                    rs.sort((a, b) => {
                        return b - a;
                    });
                    rs.filter(a => {
                        r.splice(a, 1);
                    });
                }
            }
        }
        r.forEach((a, b) => {
            a.no = Number(b) + 1;
        });
        return r;
    },
    makeData_r(s, n) {
        var r = [];
        var t = '';
        if (n > 0) {
            t = 'name';
        } else {
            t = 'code';
        }
        for (let i in s) {
            let d = {};
            for (let j in s[i]) {
                if (j != 'samples') {
                    if (Array.isArray(s[i][j])) {
                        d[j] = s[i][j][0][t];
                    } else {
                        d[j] = s[i][j];
                    }
                } else {
                    s[i].samples.forEach((a, b) => {
                        for (let k in a) {
                            d[k] = a[k];
                        }
                    })
                }
            }
            // r.push(d);
            r = r.concat(d);
            d = {}
        }
        return r;
    },
    makeData_wait(s, n) {
        var r = [];
        var t = '';
        if (n > 0) {
            t = 'name';
        } else {
            t = 'code';
        }
        for (let i in s) {
            let d = {};
            for (let j in s[i]) {
                if (j != 'samples') {
                    if (Array.isArray(s[i][j])) {
                        d[j] = s[i][j][0][t];
                    } else {
                        d[j] = s[i][j];
                    }
                } else {
                    s[i].samples.forEach((a, b) => {
                        for (let k in a) {
                            d[k] = a[k];
                        }
                    })
                }
                if (j == 'runId') {
                    d['serial'] = s[i][j];
                }
            }
            // r.push(d);
            r = r.concat(d);
            d = {}
        }
        return r;
    },
    makeHeaderData(d, s, id) {
        var r = [];
        var e = this.makeData(d, 1);
        delete s.gid;
        e.forEach(function (a) {
            delete a.samples;
            delete a.no;
            if (a.id === id) r = a;
        });
        delete r.id;
        for (let i in s) {
            r[i] = s[i]
        }
        return r;
    },
    a_overlap_c(d) {
        d = d.reduce(function (a, b, c, e) {
            var idx = 0;
            for (let i in e) {
                if (b.hasOwnProperty('detailId')) {
                    if (b.detailId === e[i].detailId) {
                        idx++
                    }
                } else {
                    if (b.sampleId === e[i].sampleId) {
                        idx++
                    }
                }
                if (idx > 1) {
                    e.splice(i, 1);
                    idx = 0;
                }
            }
        }, []);
    },
    change_data(s, d, n) { // {thisdata, rawdata, (0: code, 1:name)}
        let t = '';
        if (n > 0) {
            t = 'name';
        } else {
            t = 'code';
        }
        for (let i in d) {
            for (let j in d[i]) {
                if (s.sampleId === d[i][j].sampleId) {
                    for (let k in d[i][j]) {
                        if (Array.isArray(d[i][j][k])) {
                            s[k] = d[i][j][k][0][t];
                        }
                    }
                    break;
                }
            }
        }
        return s
    },

    find_sid_idx(h, t, v) { //v는 mid columnAttr이 같은 객체가 있을때
        var s = 0;
        for (let i in h) {
            if (v) {
                if (h[i].columnAttr === t && h[i].mid === v) {
                    s = i
                    break;
                }
            } else if (h[i].columnAttr === t) {
                s = i;
                break;
            }
        }
        return s;
    },

    find_sid_code(h, t, v) { // //v는 mid columnAttr이 같은 객체가 있을때
        var s = '';
        for (let i in h) {
            if (v) {
                if (h[i].columnAttr === t && h[i].mid === v) {
                    s = h[i].columnCode;
                    break;
                }
            } else if (h[i].columnAttr === t) {
                s = h[i].columnCode;
                break;
            }
        }
        return s;
    },

    find_codeCode_name(h, t, r) { //r == codeName (attr,codeName으로 codeCode 찾기)
        var s = '';
        for (let i in h) {
            if (h[i].columnAttr === t) {
                for (let j in h[i].code) {
                    if (h[i].code[j].codeName === r) {
                        s = h[i].code[j].codeName
                        break;
                    }
                }
            }
        }
        return s;
    },
    find_codeName_code(h, t, r) { //r == codeName (attr,codeName으로 codeCode 찾기)
        var s = '';
        for (let i in h) {
            if (h[i].columnAttr === t) {
                for (let j in h[i].code) {
                    if (h[i].code[j].codeCode === r) {
                        s = h[i].code[j].codeName
                        break;
                    }
                }
            }
        }
        return s;
    },
    find_codeCodeByName(h, t, r) { //r == codeName (attr,codeName으로 codeCode 찾기)
        var s = '';
        for (let i in h) {
            if (h[i].columnAttr === t) {
                for (let j in h[i].code) {
                    if (h[i].code[j].codeName === r) {
                        s = h[i].code[j].codeCode
                        break;
                    }
                }
            }
        }
        return s;
    },

    find_type_code(h, t) { //r == codeName (attr,codeName으로 codeCode 찾기)
        var s = '';
        h.some(a => {
            if (a.columnType == t) {
                s = a.columnCode;
                return true;
            }
        });
        return s;
    },

    find_last_column(h, t) { //r == codeName (attr,codeName으로 codeCode 찾기)
        var r = '';
        h.forEach(a => {
            if (a.columnAttr === t) r = a.columnCode
        });
        return r;
    },
    find_pre_last_result(i, d) {
        var r = '';
        var f = this.makeHeader(this.preMid(i, d), d, 2)[1];
        f.forEach(a => {
            if (a.mid == this.preMid(i, d) && a.columnAttr === 'experimentresultcode') {r = a.columnCode;}
        });
        return r;
    },
    remove_default_sample(mid, menuData, allSample, type) { // (mid(menuid), menudata, this sample data, gubun type)
        let resultCol = this.find_pre_last_result(mid, menuData);
        let arr = [];
        let thisHeader = this.makeHeader(mid, menuData)[1];
        let reIdxCol = this.find_sid_code(thisHeader, 'reexpidx', this.preMid(mid, menuData));
        if (!this.isNull(resultCol)) {
            allSample.forEach((sample) => {
                let filter = [];
                sample.forEach((item, idx) => {
                    if (this.isNull(type)) {
                        let resultData = '';
                        if(typeof item[resultCol] == 'object'){ 
                            if(!this.isNull(item[resultCol])){
                                resultData = item[resultCol][0]['name']
                            }else{
                                resultData = 'PASS'
                            }
                        }else {
                            // resultData = item[f]
                            resultData = item[resultCol];
                        }
                        if (this.isNull(item[resultCol])) filter.push(idx);
                        else if (resultData.toUpperCase() != 'PASS') filter.push(idx);


                        // let resultData = '';
                        // if(typeof item[resultCol] == 'object') resultData = item[resultCol][0]['name']
                        // else resultData = item[f]
                        // if (this.isNull(item[resultCol])) filter.push(idx);
                        // else if (resultData.toUpperCase() != 'PASS') filter.push(idx);
                    } else {
                        // 20.04.17 변경 (재실험 기준이 변경됨 - 작업 중 및 결과 없고 재실험 상태 > 0 (결과 Pass는 나타나면 안됨))
                        let resultData = '';
                        if(typeof item[resultCol] == 'object') resultData = item[resultCol][0]['name']
                        else resultData = item[resultCol]
                        if (item[reIdxCol] > 0) { 
                            if (resultData.trim().toUpperCase() != 'REWAIT') filter.push(idx);
                        }else{
                            filter.push(idx);
                        }
                    }
                });
                filter.sort((b, c) => {
                    return c - b;
                });
                filter.forEach(b => {
                    sample.splice(b, 1);
                });
            });
            allSample.forEach((a, b) => {
                if (a.length <= 0) arr.push(b);
            });
            arr.sort((a, b) => {
                return b - a;
            });
            arr.forEach(a => {
                allSample.splice(a, 1);
            })
        }
        return allSample;
    },
    remove_default(d) {
        let s = [];
        d.forEach((a, b) => {
            if (a.samples.length <= 0) s.push(b)
        });
        s.sort((a, b) => {
            return b - a;
        });
        s.forEach(a => {
            d.splice(a, 1);
        });
        d.forEach((a, b) => {
            a.no = b + 1;
        });
        return d;
    },
    find_last_column_idx(h, t) {
        var r = '';
        var s = this.find_last_column(h, t);
        h.some((a, b) => {
            if (a.columnCode === s) {
                s = b;
                return true
            }
        })
        return s;
    },

    plateReload(fid, fb, tid, tb) {
        // plate 등록 순서는 A1, B1, C1, ... H12 순서로 넣는다고 함 (실험 시 기본 노하우)
        let well_column = 12;
        let well_row = 8;
        let well_row_a = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];

        let flist = document.getElementById(fid);
        let tlist = document.getElementById(tid);
        // console.log(flist.childNodes(fb))
        let fidx = 0;
        let ftag = '';
        let tidx = 0;
        let ttag = '';
        for(let i in flist.childNodes){
            if (fb == flist.childNodes[i].id) {
                ftag = flist.childNodes[i];
                fidx = i;
            }
            if (tb == tlist.childNodes[i].id) {
                ttag = tlist.childNodes[i];
                tidx = i;
            }
        }

        flist.insertBefore(ttag, flist.childNodes[fidx]);
        tlist.insertBefore(ftag, tlist.childNodes[tidx]);
        // tlist.replaceChild(ftag, tlist.childNodes[tidx]);
        // flist.replaceChild(ttag, flist.childNodes[fidx]);

        let fid_idx = fid.substring(0,fid.indexOf('-')).substring(4);
        let tid_idx = tid.substring(0,tid.indexOf('-')).substring(4);
        let l_id_idx = Number(fid_idx) > Number(tid_idx) ? Number(fidx_idx) : Number(tid_idx);

        for( let h = 0; h < l_id_idx; h++){
            outer: for (let j = 0; j < well_column; j++) {
                inner: for (let k = 0; k < well_row; k++) {
                    let list = document.getElementById('list'+(Number(h)+1)+'-'+(k + 1));
                    if(list.childNodes[j].innerText.replace(/[0-9]/g, '') != ''){
                        list.childNodes[j].innerText = well_row_a[k] + (Number(j) + 1);
                    }
                }
            }
        }
    },
    plateDataChange(w, i, d) {
        let s = [];
        let m = [];
        let r = [];
        // plate 등록 순서는 A1, B1, C1, ... H12 순서로 넣는다고 함 (실험 시 기본 노하우)
        let well_column = 12;
        let well_row = 8;
        let well_row_a = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
        for( let h = 0; h < w; h++){
            outer: for (let j = 0; j < well_column; j++) {
                inner: for (let k = 0; k < well_row; k++) {
                    let list = document.getElementById('list'+h+'-'+(k + 1));
                    if(list.childNodes[j].innerText.replace(/[0-9]/g, '') == ''){
                        s.push(well_row_a[k] + (Number(j) + 1));
                    }
                }
            }
        }
        d.forEach(a => {
            m.push(a[i])
        })
        d.forEach((a, b) => {
            if (s.indexOf(a[i]) < 0) {
                s.some((c, d) => {
                    if (m.indexOf(c) < 0) {
                        r.push([b, c]);
                        s.splice(d, 1);
                        return true;
                    }
                })
            }
        })
        return r;
    },
    thisDetailResult(i, m) {
        let r = [];
        m.some(a => {
            a.subs.some(b => {
                if (b.id === i) {
                    b.detailColumn.some(c => {
                        if (c.columnAttr === "experimentresultcode") {
                            r = c.code;
                            return true;
                        }
                    });
                }
            });
        });
        r.sort(function (a, b) {
            return a.codesort - b.codesort;
        })
        return r;
    },
    rndStr(len) {
        let text = " "
        let chars = "abcdefghijklmnopqrstuvwxyz"

        for (let i = 0; i < len; i++) text += chars.charAt(Math.floor(Math.random() * chars.length))
        return text
    },
    thisZeroDataSplice(d) {
        let s = [];
        d.forEach((a, b) => {
            if (a.length === 0) s.push(b);
        });
        if (s.length > 0) {
            s.sort((a, b) => {
                return b - a;
            });
            s.forEach(a => {
                d.splice(a, 1);
            });
        }
        return d;
    },
    menuidSearch(d, n) {
        let r = '';
        d.forEach(a => {
            a.subs.some(b => {
                if (b.menuRoute == n) r = b.id
            })
        })
        return r;
    },
    thousandSepar(value) {
        if (typeof value == 'number') {
            let parts = value.toString().split(".")
            return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] ? "." + parts[1] : "")
        } else {
            return value
        }
    },
    findRequiredByHeader(header) { //필수 컬럼 
        let required = [];
        for (let i in header) {
            if (header[i].columnDivision == 'C' && header[i].columnAttr) {
                required.push({columnName: header[i].columnName, columnCode: header[i].columnCode, columnType: header[i].columnType,columnAttr :header[i].columnAttr});
            }
        }

        return required;
    },
    findIdxByAttr(header, attr) {
        let result = 0;
        for (let i in header) {
            if (header[i].columnAttr == attr) {
                result = Number(i);
            }
        }
        return result;
    },
    
    arrUnique(arr) {
        var cleaned = [];
        arr.forEach(function(itm) {
            var unique = true;
            
            cleaned.forEach(function(itm2) {
                if (_.isEqual(itm, itm2)) unique = false;
            });
            if (unique)  cleaned.push(itm);
        });
        return cleaned;
    },
    arrFieldUnique(arr) {
        var cleaned = [];
        arr.forEach(function(itm) {
            var unique = true;
            
            cleaned.forEach(function(itm2) {
                if (_.isEqual(itm.field, itm2.field)) unique = false;
            });
            if (unique)  cleaned.push(itm);
        });
        return cleaned;
    },
    changecss(theClass,element,value) {
        var cssRules;
        if (document.all) cssRules = 'rules';
        else if (document.getElementById) cssRules = 'cssRules';
        var added = false;
        for (var S = 0; S < document.styleSheets.length; S++){
            for (var R = 0; R < document.styleSheets[S][cssRules].length; R++){
                if (document.styleSheets[S][cssRules][R].selectorText == theClass){
                    if(document.styleSheets[S][cssRules][R].style[element]){
                        document.styleSheets[S][cssRules][R].style[element] = value;
                        added=true;
                        break;
                    }
                }
            }
            if(!added){
                if(document.styleSheets[S].insertRule){
                    document.styleSheets[S].insertRule(theClass+' { '+element+': '+value+';}',document.styleSheets[S][cssRules].length);
                }
                else if (document.styleSheets[S].addRule){
                    document.styleSheets[S].addRule(theClass,element+': '+value+';');
                }
            }
        }
    },
    originalSampleSheetExport(platingHeader,platingSamples,platingData,sampleHeader){
        let headerData = {}
        // 2. sample sheet make data
        platingHeader.forEach(result => {
            if(result.columnAttr == 'platingno'){
                headerData.platingNo = platingData[result.columnCode]
            }
            if(result.columnAttr == 'cycle'){
                if(!this.isNull(platingData[result.columnCode])){
                    let read = this.find_codeName_code(platingHeader,'cycle',platingData[result.columnCode]).split('-')
                    headerData.read1 = read[0]
                    headerData.read2 = read[3]
                }
            }
            if(result.columnAttr == 'index'){
                if(!this.isNull(platingData[result.columnCode])){
                    headerData.index = this.find_codeName_code(platingHeader,'index',platingData[result.columnCode])
                }
            }
            if(result.columnAttr == 'createdate'){
                let form = "MM/DD/YYYY";
                headerData.createDate = moment(platingData[result.columnCode]).format(form);
            }
        })
    
        var array = [
            ["[Header]", '', '', '', '', '', '', '', '', '' ],
            ['IEMFileVersion', '5', '', '', '', '', '', '', '', ''],
            ["Investigator Name","LIMS",'', '', '', '', '', '', '', ''],
            ["Experiment Name",headerData.platingNo, '', '', '', '', '', '', '', '' ],
            ["Date",headerData.createDate, '', '', '', '', '', '', '', '' ],
            ["Workflow","Metagenomics", '', '', '', '', '', '', '', '' ],
            ["Application","Metagenomics 16S rRNA", '','','','','','','',''],
            ["Instrument Type","MiSeq", '', '', '', '', '', '', '', '' ],
            ["Assay","Nextera XT", '', '', '', '', '', '', '', '' ],
            ["Index Adapters",headerData.index,  '',  '',  '',  '',  '',  '',  '',  ''],
            ["Description", '', '', '', '', '', '', '', '', '' ],
            ["Chemistry","Amplicon", '', '', '', '', '', '', '', '' ],
            ['', '', '', '', '','', '', '', '', ''],
            ['[Reads]','', '', '', '', '', '', '', '', '' ],
            [headerData.read1,'','','','', '','','', '',''],
            [headerData.read2,'','','','', '','','', '',''],
            [ '', '', '', '', '','', '', '', '', ''],
            ["[Settings]", '', '', '', '', '', '', '', '', '' ],
            ["Adapter","CTGTCTCTTATACACATCT", '', '', '', '', '', '', '', '' ],
            [ '', '', '', '', '','', '', '', '', ''],
            ["[Data]", '', '', '', '', '', '', '', '', ''],
            ["Sample_ID","Sample_Name","Sample_Plate","Sample_Well","I7_Index_ID","index","I5_Index_ID","index2","Sample_Project","Description"],
        ];
        for(let i of platingSamples){
            let excelData = [];
            let i7id = i[`${sampleHeader.find(header => header.columnAttr == 'i7id').columnCode}`];
            let i5id = i[`${sampleHeader.find(header => header.columnAttr == 'i5id').columnCode}`];
            let i7seq = i[`${sampleHeader.find(header => header.columnAttr == 'i7seq').columnCode}`];
            let i5seq = i[`${sampleHeader.find(header => header.columnAttr == 'i5seq').columnCode}`];
            excelData[0] = i.sampleNo;
            excelData[1] = i.sampleNo;
            excelData[4] = i7id;
            excelData[5] = i5id;
            excelData[6] = i7seq;
            excelData[7] = i5seq;
            excelData[9] = i.duid;
            array.push(excelData)
        }
        var str = '';
        for (var i = 0; i < array.length; i++) { 
            let line = '';
            line = array[i].join(",");
            str += line + '\r\n';
        }
        var blob = new Blob([str], { type: 'text/csv;charset=utf-8;' });
        var link = document.createElement('a');
        var url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', 'SampleSheet_Origin.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },
    LRMSampleSheetExport(platingHeader,platingSamples,platingData,sampleHeader){
        let headerData = {}
        // 2. sample sheet make data
        platingHeader.forEach(result => {
            if(result.columnAttr == 'platingno'){
                headerData.platingNo = platingData[result.columnCode];
            }
            if(result.columnAttr == 'cycle'){
                if(!this.isNull(platingData[result.columnCode])){
                    let read = this.find_codeName_code(platingHeader,'cycle',platingData[result.columnCode]).split('-')
                    headerData.read1 = read[0];
                    headerData.read2 = read[3];
                }
            }
            if(result.columnAttr == 'index'){
                if(!this.isNull(platingData[result.columnCode])){
                    headerData.index = this.find_codeName_code(platingHeader,'index',platingData[result.columnCode]);
                }
            }
            if(result.columnAttr == 'createdate'){
                let form = "YYYY-MM-DD";
                headerData.createDate = moment(platingData[result.columnCode]).format(form);
            }
        })
    
        var array = [
            ["[Header]", '', '', '', '', '', '', '', '', '' ],
            ["Local Run Manager Analysis Id",'', '', '', '', '', '', '', '', '' ],
            ["Experiment Name",headerData.platingNo, '', '', '', '', '', '', '', '' ],
            ["Date",headerData.createDate, '', '', '', '', '', '', '', '' ],
            ["Module","GenerateFASTQ - 3.0.1", '', '', '', '', '', '', '', '' ],
            ["Workflow","GenerateFASTQ", '', '', '', '', '', '', '', '' ],
            ["Library Prep Kit","Nextera XT", '','','','','','','',''],
            ["Index Kit","Nextera XT v2 Index Kit Sets A B C D", '', '', '', '', '', '', '', '' ],
            ["Description", '', '', '', '', '', '', '', '', '' ],
            ["Chemistry","Amplicon", '', '', '', '', '', '', '', '' ],
            ['','', '', '', '', '', '', '', '', '' ],
            ['[Reads]','', '', '', '', '', '', '', '', '' ],
            [headerData.read1,'','','','', '','','', '',''],
            [headerData.read2,'','','','', '','','', '',''],
            ['','', '', '', '', '', '', '', '', '' ],
            ["[Settings]", '', '', '', '', '', '', '', '', '' ],
            ["adapter","CTGTCTCTTATACACATCT", '', '', '', '', '', '', '', '' ],
            ['','', '', '', '', '', '', '', '', '' ],
            ["[Data]", '', '', '', '', '', '', '', '', ''],
            ["Sample_ID","Sample_Name","Description","I7_Index_ID","index","I5_Index_ID","index2","Sample_Project"],
        ];
        for(let i of platingSamples){
            let excelData = [];
            let i7id = i[`${sampleHeader.find(header => header.columnAttr == 'i7id').columnCode}`];
            let i5id = i[`${sampleHeader.find(header => header.columnAttr == 'i5id').columnCode}`];
            let i7seq = i[`${sampleHeader.find(header => header.columnAttr == 'i7seq').columnCode}`];
            let i5seq = i[`${sampleHeader.find(header => header.columnAttr == 'i5seq').columnCode}`];

            excelData[0] = i.sampleNo;
            excelData[1] = i.sampleNo;
            excelData[2] = i.duid;
            excelData[3] = i7id.split("-")[1]+"-"+i7id.split("-")[0];
            excelData[4] = i7seq;
            excelData[5] = i5id.split("-")[1]+"-"+i5id.split("-")[0];
            excelData[6] = i5seq;
            excelData[7] = '';
            array.push(excelData);
        }
        var str = '';
        for (var i = 0; i < array.length; i++) { 
            let line = '';
            line = array[i].join(",");
            str += line + '\r\n';
        }
        var blob = new Blob([str], { type: 'text/csv;charset=utf-8;' });
        var link = document.createElement('a');
        var url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', 'SampleSheet_LRM.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },
    dataRangeWork(column, data) {
        let first = '';
        let end = '';
        first = 'f_' + column.columnCode;
        end = 'e_' + column.columnCode;
        let range = '';
        if (!data[first]) {
            data[first] = '';
        }
        if (!data[end]) {
            data[end] = '';
        }
        range =  data[first] + '~' + data[end];
        if (!data[first] && !data[end]) {
            range = '';
        } 

        return range;
    },
    // 배열 중복값 개수 세기
    JSONstringify(arr){
        const result = {};
        arr.forEach((x) => { 
        result[x] = (result[x] || 0)+1; 
        });
        return JSON.stringify(result).replace('{', '').replace('}','').replace(/"/gi, '');
    }
}



// WEBPACK FOOTER //
// ./src/views/Common/common.js